<template>
  <el-container direction="vertical">
    <edu-head></edu-head>
    <el-main>
      <div class="right-tip">
        <el-backtop :right="0" :visibility-height="100">

            <a @mouseenter="showTipIndex = 4" @mouseleave="showTipIndex = 0">
              <i class="el-icon-arrow-up" :style="showTipIndex === 4 ? 'display: none': 'font-size: 24px;line-height:32px;'"></i>
              <span :style="showTipIndex !== 4 ? 'display: none': ''">返回顶部</span>
            </a>

        </el-backtop>
        <a v-for="(item,index) in ['意见反馈','帮助中心','协会主页']"
           style="cursor: pointer"
           @mouseenter="showTipIndex = index+1"
           @mouseleave="showTipIndex = 0"
           @click="changeView(index)">
          <i :class=icons[index] :style="showTipIndex === index + 1 ? 'display: none': 'font-size: 24px;line-height:32px;'"></i>
          <span :style="showTipIndex !== index + 1 ? 'display: none': ''">{{item}}</span>
        </a>
      </div>

      <!--意见反馈dialog-->
      <idea-dialog ref="ideaDialog"></idea-dialog>

      <router-view></router-view>
    </el-main>
    <edu-foot></edu-foot>
  </el-container>
</template>

<script>
  const EduHead = () => import('../components/EduHead');
  const EduFoot = () => import('../components/EduFoot');
  const IdeaDialog =() => import('../components/IdeaDialog')
  export default {
    name: "Home",
    data(){
      return {
        // viewStyle: {},
        showTipIndex: 0,
        icons: ['el-icon-chat-dot-square','el-icon-question','el-icon-link'],
      }
    },
    // watch:{
    //   '$store.state.screenHeight': function (screenHeight) {
    //     let height = document.getElementById('view').offsetHeight;
    //     this.viewStyle = {marginTop: (screenHeight-height>243) ? (screenHeight-height-223)+'px' : '20px'}
    //   }
    // },
    // mounted() {
    //   let self = this;
    //   const resizeObserver = new ResizeObserver(entries => {
    //     let screenHeight = document.documentElement.clientHeight;
    //     let height = entries[0].contentRect.height;
    //     self.viewStyle = {marginTop: (screenHeight-height>243) ? (screenHeight-height-223)+'px' : '20px'}
    //   });
    //   resizeObserver.observe(document.getElementById('view'));
    // },
    methods: {
      changeView(index){
        switch (index) {
          case 0: this.$refs.ideaDialog.showDialog(); break;
          case 1: { const { href } = this.$router.resolve('/home/help'); window.open(href, '_blank') } break;
          case 2: window.open('http://www.gdjsjcjdxh.com/','_blank'); break;
        }
      },
    },
    components: {
      EduHead,
      EduFoot,
      IdeaDialog
    }
  }
</script>

<style lang="scss" scoped>
  .el-container{
    position: relative;
    min-height: 100%;
    flex-flow: column;
  }
  .el-main {
    padding: 0 0 96px;
    overflow: inherit;
  }
  .el-backtop{
    /*top: calc(50% + 306px);*/
    bottom: calc(5% + 34px) !important;
    width: 26px;
    height: 65px;
    right: 15px !important;
    padding: 0 16px;
    border-radius: 0;
    box-shadow: -3px 6px 10px 0 rgba(7, 17, 27, 0.1);
    border: 1px solid #e5e5e5;
    border-top:  0;
  }
  .el-backtop:hover{
    background-color: #fff;
  }
  .right-tip {
    position: fixed;
    padding: 0 16px;
    /*top: calc(50% + 110px);*/
    bottom: calc(5% + 100px);
    right: 15px;
    background-color: #fff;
    box-shadow: -3px 3px 10px 0 rgba(7, 17, 27, 0.1);
    border: 1px solid #e5e5e5;
    border-bottom: 0;
    z-index: 850;
  }
  .right-tip a{
    display: block;
    width: 26px;
    padding: 16px 0;
    line-height: 16px;
    color: #b5b9bc;
    box-sizing: border-box;
    text-align: center;
    border-bottom: 1px solid #edf1f2;
    text-decoration: none;
  }
  .right-tip a span{
    font-size: 12px;color: #07111b;line-height: 10px;
  }
</style>
